<template>
  <v-row no-gutters fill-height>
    <v-col offset="2" cols="8" v-if="device === 'mobile'"  style="background:#fff; padding:30px; ">
        <div>
          <img src="https://storage.googleapis.com/cdn.avecor.fi/avecor-logo-no-slogan-200x57.png" alt="Avecor Logo"  style="max-width:200px; height:57px;">
        </div>
        <div>
          <span v-if="isSales || isAdmin" style="color:#111">Käytä Avecorin sähköpostia kirjautuessasi sisään. <br>Onnistuneen kirjautumisen jälkeen, sinut ohjataan automaattisesti <b>myyntijärjestelmään.</b></span>
          <span v-if="isOffice" style="color:#111">Käytä Avecorin sähköpostia kirjautuessasi sisään. <br>Onnistuneen kirjautumisen jälkeen, sinut ohjataan automaattisesti <b>office-näkymään.</b></span>
          <span v-if="isWarehouse" style="color:#111">Käytä Avecorin sähköpostia kirjautuessasi sisään. <br>Onnistuneen kirjautumisen jälkeen, sinut ohjataan automaattisesti <b>varasto-näkymään.</b></span>
        </div>
        <div class="mt-10" id="firebaseui-auth-container"></div>
    </v-col>
    <v-navigation-drawer
      v-if="device === 'desktop'"
      permanent
      style="/*background:#111111*/ backgound:#FFF"
      :right="right"
      v-model="rightDrawer"
      :mini-variant="miniVariant"
      mini-variant-width="500"
      fixed
      app
      class="px-6"
    >
      <v-col class="mt-10 pt-15 mb-5">
        <img src="https://storage.googleapis.com/cdn.avecor.fi/avecor-logo-no-slogan-200x57.png" alt="Avecor Logo"  style="max-width:200px; height:57px;">
      </v-col>
      <v-col  v-if="!isAuthenticated">
        <div>
          <span v-if="isSales || isAdmin" style="color:#111">Käytä Avecorin sähköpostia kirjautuessasi sisään. <br>Onnistuneen kirjautumisen jälkeen, sinut ohjataan automaattisesti <b>myyntijärjestelmään.</b></span>
          <span v-if="isOffice" style="color:#111">Käytä Avecorin sähköpostia kirjautuessasi sisään. <br>Onnistuneen kirjautumisen jälkeen, sinut ohjataan automaattisesti <b>office-näkymään.</b></span>
          <span v-if="isWarehouse" style="color:#111">Käytä Avecorin sähköpostia kirjautuessasi sisään. <br>Onnistuneen kirjautumisen jälkeen, sinut ohjataan automaattisesti <b>varasto-näkymään.</b></span>
        </div>
        <div class="mt-10" id="firebaseui-auth-container"></div>
      </v-col>
    </v-navigation-drawer>
  </v-row>
</template>


<script>
import { mapFields } from 'vuex-map-fields'

export default {
    data: () => ({
        autogrow:true,
        clipped: true,
        email: '',
        password: '',
        passwordConfirm: '',
        isTopBarFlat:true,
        clipped: true,
        clippedToolbar:true,
        alert: false,
        right: true,
        rightDrawer: true,
        hideSlider:true,
        miniVariant: true,
        activeTab:'tab-3',
    }),
    mounted() {
      
    },
    computed: {
      isAuthenticated () {
        return this.$store.getters.isAuthenticated
      },
      error () {
        return this.$store.state.error
      },
      ...mapFields([
        'device',
        'settings.isAuthenticated',
        'settings.isSales',
        'settings.isOffice',
        'settings.isAdmin',
        'settings.isWarehouse',
        'user',
        
      ]),
    },
    created () {},
    methods: {
      userSignUp () {
        if (this.comparePasswords !== true) {
          return
        }
        this.$store.dispatch('userSignUp', { email: this.email, password: this.password })
      },
      loginUserWithOnlyEmail () {
        this.$store.dispatch('userSignInWithOnlyEmail', { email: this.email })
      },
      loginUser () {
        this.$store.dispatch('userSignIn', { email: this.email, password: this.password })
      },
      resetUserPassword () {
        this.$store.dispatch('resetPassword', { email: this.email })
      },
    }
  }
</script>

<style>
.firebaseui-container {
  margin: unset !important;
}
.firebaseui-card-content {
  text-align:left;
  padding:0px !important;
}
.firebaseui-idp-list {
  padding:0px !important;
  margin:0px !important;
}
.firebaseui-list-item{
  text-align:left !important;
}


</style>


// WEBPACK FOOTER //
// src/components/views/Login.vue